<template>
  <div>
    <main-header />
    <div class="main-wrap">
      <div class="section-visual">
        <div class="title m_hidden"><img src="//img.eduwill.net/resources/b2b/dev/images/main/pc-title@2x.png" alt=""/></div>
        <div class="title pc_hidden"><img src="//img.eduwill.net/resources/b2b/dev/images/main/mo-title@2x.png" alt=""/></div>
        <div class="action">
          <a href="//pds.eduwill.net/Common/에듀윌_B2B브로슈어.pdf" target="_blank" class="btn-1"><strong>B2B</strong>
            브로슈어<i class="icon icon-arrow"></i></a>
          <a href="javascript:;" class="btn-2" @click="showCounsel('01')"><strong>B2B</strong> 상담신청<i class="icon icon-arrow"></i></a>
        </div>
      </div>
      <div class="section-intro">
        <div class="container">
          <div class="section-subject">
            <div class="title">
              NO.1<br>
              <em>B2B</em> Edu-Partner
            </div>
            <div class="desc">
              에듀윌은 기업, 공공기관, 대학 등 <br class="pc_hidden"><strong>고객사에 최적화된 맞춤 서비스를 제공합니다.</strong>
            </div>
          </div>

          <ul>
            <li>
              <i class="icon icon-1"></i>
              <div class="t1">폭넓은 교육과정</div>
              <div class="t2">전문 분야, 재취업, 창업, 은퇴 교육 등<br>40여 분야의 교육 서비스를 제공</div>
            </li>
            <li>
              <i class="icon icon-2"></i>
              <div class="t1">스마트 러닝</div>
              <div class="t2">시간·공간 구애 없이 언제 어디서나<br>학습할 수 있는 스마트러닝 콘텐츠</div>
            </li>
            <li>
              <i class="icon icon-3"></i>
              <div class="t1">성장 멘토 교수진</div>
              <div class="t2">성장을 코칭하는 멘토로서<br>학습자와 함께 하는 에듀윌 교수진</div>
            </li>
            <li>
              <i class="icon icon-4"></i>
              <div class="t1">맞춤 커리큘럼</div>
              <div class="t2">고객사별 특성에 맞춘<br>교육 시스템과 전문 커리큘럼 제공</div>
            </li>
          </ul>

        </div>
      </div>

      <div class="section-menu">
        <div class="bg m_hidden">
          <div class="item-1"></div>
          <div class="item-2" style="display: none;"></div>
          <div class="item-3" style="display: none;"></div>
          <div class="item-4" style="display: none;"></div>
          <div class="item-5" style="display: none;"></div>
        </div>
        <div class="container">
          <div class="item">
            <div class="item-5">
              <dl>
                <dt>AI 교육
                  <a href="/edu/aiEdu/Aiclass" class="more">More<i class="icon icom-arrow"></i></a>
                </dt>
                <dd><a href="/edu/aiEdu/Main">・ AICE</a></dd>
                <dd><a href="/edu/aiEdu/Aiclass">・ AI CLASS</a></dd>
                <dd><a href="/edu/aiEdu/b2b">・ AI 기업교육</a></dd>
              </dl>
            </div>
            <div class="item-1">
              <dl>
                <dt>온라인 교육
                  <a href="/edu/onlineEdu/main" class="more">More<i class="icon icom-arrow"></i></a>
                </dt>
                <dd><a href="/edu/onlineEdu/main">・ 기업 위탁교육</a></dd>
                <dd><a href="/edu/onlineEdu/uniSell">・ 대학 취업교육</a></dd>
                <dd><a href="/edu/onlineEdu/highSell">・ 특성화고 취업교육</a></dd>
              </dl>
            </div>
            <div class="item-2">
              <dl>
                <dt>집합·화상교육
                  <a href="/edu/zoomEdu/main" class="more">More<i class="icon icom-arrow"></i></a>
                </dt>
                <dd><a href="/edu/zoomEdu/main">・ 집합 교육</a></dd>
                <dd><a href="/edu/zoomEdu/zoomEdu">・ 화상 교육(Zoom)</a></dd>
              </dl>
            </div>
            <div class="item-3">
              <dl>
                <dt>콘텐츠 공급·제휴
                  <a href="/edu/cpEdu/main" class="more">More<i class="icon icom-arrow"></i></a>
                </dt>
                <dd><a href="/edu/cpEdu/main">・ 콘텐츠·멤버십 제휴</a></dd>
                <dd><a href="/edu/cpEdu/cpMallEdu">・ 제휴몰 사업</a></dd>
                <dd><a href="/edu/cpEdu/contentProviederEdu">・ 교육 협약</a></dd>
              </dl>
            </div>
            <div class="item-4">
              <dl>
                <dt>홍보센터
                  <a href="/edu/newsRelease/main" class="more">More<i class="icon icom-arrow"></i></a>
                </dt>
                <dd><a href="/edu/newsRelease/main">・ 보도자료</a></dd>
                <dd><a href="/edu/newsRelease/promotionVideo">・ 홍보영상</a></dd>
              </dl>
            </div>
          </div>
        </div>
      </div>

      <div class="section-review">
        <div class="container">
          <div class="section-subject">
            <div class="title">
              “에듀윌 <em>B2B</em> 교육서비스, 어떠셨나요?”
            </div>
          </div>

          <div class="crown">
            <ul>
              <li class="crown-1">
                <span>콘텐츠 만족도 <em>98%</em></span>
              </li>
              <li class="crown-2">
                <span>응대 만족도 <em>98%</em></span>
              </li>
              <li class="crown-3">
                <span>지인 추천 의향 <em>100%</em></span>
              </li>
            </ul>
            <div class="desc">*2021-2022 에듀윌 에듀윌 온라인 위탁교육 진행 기업 대상 설문조사 결과</div>
          </div>

          <div class="item-slick-title">전국 교육 담당자가 인정한 진짜 후기!</div>

          <div class="item-slick item-slick-main">
            <div class="slick-inner">
              <div class="box">
                <div class="text">
                  높은 수준과<br>빠른 피드백
                </div>
                <div class="who">
                  한국남동발전<br>교육 담당자
                </div>
                <div class="img img-1"><img
                    src="//img.eduwill.net/resources/b2b/dev/images/main/roll-img-01.png"></div>
              </div>
            </div>
            <div class="slick-inner">
              <div class="box">
                <div class="text">
                  교육에 앞서<br>
                  간과할 수 있는 부분은<br>
                  미리 선제조치 해주시고,<br>
                  요구 사항에 맞게<br>
                  반영해 주십니다.
                </div>
                <div class="who">
                  KOICA 개발협력<br>
                  커리어센터 담당자
                </div>
                <div class="img img-2"><img
                    src="//img.eduwill.net/resources/b2b/dev/images/main/roll-img-02.png"></div>
              </div>
            </div>
            <div class="slick-inner">
              <div class="box">
                <div class="text">
                  스케줄 관리, <br>
                  콘텐츠 관리 <br>
                  모두 완벽합니다.
                </div>
                <div class="who">
                  영흥발전본부<br>
                  교육 담당자
                </div>
                <div class="img img-3"><img
                    src="//img.eduwill.net/resources/b2b/dev/images/main/roll-img-03.png"></div>
              </div>
            </div>
            <div class="slick-inner">
              <div class="box">
                <div class="text">
                  다양한 컨텐츠 제공, <br>
                  친절한 상담, <br>
                  신속한 업무처리!
                </div>
                <div class="who">
                  한국장애인고용공단<br>
                  교육 담당자
                </div>
                <div class="img img-4"><img
                    src="//img.eduwill.net/resources/b2b/dev/images/main/roll-img-04.png"></div>
              </div>
            </div>
            <div class="slick-inner">
              <div class="box">
                <div class="text">
                  역시 전문 기관답게<br>
                  교육 자료와 <br>
                  프로그램 수준이 <br>
                  높습니다.
                </div>
                <div class="who">
                  셀트리온제약<br>
                  교육 담당자
                </div>
                <div class="img img-5"><img
                    src="//img.eduwill.net/resources/b2b/dev/images/main/roll-img-05.png"></div>
              </div>
            </div>
            <div class="slick-inner">
              <div class="box">
                <div class="text">
                  수강생과 <br>
                  교육 프로그램에 대해 <br>
                  세심하게 챙겨주는 모습이 <br>
                  좋았습니다.
                </div>
                <div class="who">
                  대전지방보훈청 <br>
                  교육 담당자
                </div>
                <div class="img img-6"><img
                    src="//img.eduwill.net/resources/b2b/dev/images/main/roll-img-06.png"></div>
              </div>
            </div>
            <div class="slick-inner">
              <div class="box">
                <div class="text">
                  우리회사에 딱! 맞는 <br>
                  서비스를 제공해주려고 <br>
                  노력해주십니다.
                </div>
                <div class="who">
                  ㈜ 한익스프레스<br>
                  인사 담당자
                </div>
                <div class="img img-7"><img
                    src="//img.eduwill.net/resources/b2b/dev/images/main/roll-img-07.png"></div>
              </div>
            </div>
            <div class="slick-inner">
              <div class="box">
                <div class="text">
                  교육 내용이 너무 좋고<br>
                  교육 사이트도 <br>
                  사용하기 편합니다.
                </div>
                <div class="who">
                  대한솔루션 <br>
                  교육 담당자
                </div>
                <div class="img img-8"><img
                    src="//img.eduwill.net/resources/b2b/dev/images/main/roll-img-08.png"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-curriculum">
        <div class="container">
          <div class="section-subject">
            <div class="title">
              Curriculum
            </div>
            <div class="desc">
              진정한 교육의 힘이 제대로 실현되는 기회, <br class="pc_hidden"><strong>에듀윌이 준비한 다양한 콘텐츠를 경험해 보세요.</strong>
            </div>
          </div>
          <ul>
            <li onclick="show_curriculum(19)">
              <i class="icon icon-19"></i>
              <div class="t1">AI 교육<i class="icon-new"></i></div>
            </li>
            <li onclick="show_curriculum(1)">
              <i class="icon icon-1"></i>
              <div class="t1">재무<i class="icon-new"></i></div>
            </li>
            <li onclick="show_curriculum(2)">
              <i class="icon icon-2"></i>
              <div class="t1">부동산·주택관리<i class="icon-new"></i></div>
            </li>
            <li onclick="show_curriculum(3)">
              <i class="icon icon-3"></i>
              <div class="t1">전기·소방</div>
            </li>
            <li onclick="show_curriculum(4)">
              <i class="icon icon-4"></i>
              <div class="t1">위험물·산업안전</div>
            </li>
            <li onclick="show_curriculum(5)">
              <i class="icon icon-5"></i>
              <div class="t1">건축·토목</div>
            </li>
            <li onclick="show_curriculum(6)">
              <i class="icon icon-6"></i>
              <div class="t1">물류·유통·무역</div>
            </li>
            <li onclick="show_curriculum(7)">
              <i class="icon icon-7"></i>
              <div class="t1">경비·행정·감정</div>
            </li>
            <li onclick="show_curriculum(8)">
              <i class="icon icon-8"></i>
              <div class="t1">상담·복지</div>
            </li>
            <li onclick="show_curriculum(9)">
              <i class="icon icon-9"></i>
              <div class="t1">경제·경영·시사</div>
            </li>
            <li onclick="show_curriculum(10)">
              <i class="icon icon-10"></i>
              <div class="t1">한국사·한국어</div>
            </li>
            <li onclick="show_curriculum(11)">
              <i class="icon icon-11"></i>
              <div class="t1">IT자격증</div>
            </li>
            <li onclick="show_curriculum(12)">
              <i class="icon icon-12"></i>
              <div class="t1">NCS·취업</div>
            </li>
            <li onclick="show_curriculum(13)">
              <i class="icon icon-13"></i>
              <div class="t1">전직지원·창업<i class="icon-new"></i></div>
            </li>
            <li onclick="show_curriculum(14)">
              <i class="icon icon-14"></i>
              <div class="t1">HRD· 전문직무<i class="icon-new"></i></div>
            </li>
            <!-- <li onclick="show_curriculum(15)">
                <i class="icon icon-15"></i>
                <div class="t1">산업안전보건</div>
            </li> -->
            <li onclick="show_curriculum(16)">
              <i class="icon icon-16"></i>
              <div class="t1">어학<i class="icon-new"></i></div>
            </li>
            <li onclick="show_curriculum(17)">
              <i class="icon icon-17"></i>
              <div class="t1">편입<i class="icon-new"></i></div>
            </li>
            <li onclick="show_curriculum(18)">
              <i class="icon icon-18"></i>
              <div class="t1">인사·노무<i class="icon-new"></i></div>
            </li>
          </ul>
        </div>
      </div>

      <div class="section-why">
        <div class="container">
          <div class="section-subject">
            <div class="title">
              Why Eduwill?
            </div>
            <div class="desc">
              교육을 통한 변화, 교육으로 만드는 성과 <br class="pc_hidden"><strong>압도적인 수치가 능력을 증명합니다.</strong>
            </div>
          </div>
          <div class="row-box">
            <div class="img m_hidden">
              <img src="//img.eduwill.net/resources/b2b/dev/images/main/img_whyeduwill2.png" alt="" />
            </div>
            <div class="img pc_hidden">
              <img src="//img.eduwill.net/resources/b2b/dev/images/main/img-whyeduwill-tbl.png" alt="" />
            </div>
            <ul>
              <li>
                <div class="box">
                  <div class="m_hidden"><i class="icon icon-2"></i></div>
                  <div class="t1">
                    <div class="pc_hidden"><i class="icon icon-2"></i></div>10년 간 아무도 깨지 못한 합격자 수 1위*
                  </div>
                  <div class="t2">*단일교육기관(전국 직영학원, 온라인 수강생 합산) 2016, 2017, 2019년 공인중개사 한 회차 최다 합격자 배출
                    공식 인증(KRI 한국 기록원/2016, 2017, 2019년 인증, 2026년 현재까지 업계 최고 기록</div>
                </div>
              </li>
              <li class="line-1">
                <div class="box">
                  <div class="m_hidden"><i class="icon icon-1"></i></div>
                  <div class="t1">
                    <div class="pc_hidden"><i class="icon icon-1"></i></div>정부기관상 19관왕*
                  </div>
                  <div class="t2">*대통령상 3관왕 및 정부기관상 포함, 에듀윌 홈페이지 상세 명시</div>
                </div>
              </li>
              <li class="line-1">
                <div class="box">
                  <div class="m_hidden"><i class="icon icon-4"></i></div>
                  <div class="t1">
                    <div class="pc_hidden"><i class="icon icon-4"></i></div>ESG 경영 우수 기업 인증*
                  </div>
                  <div class="t2">*교육업계 ESG 경영을 선도하며 NICE평가정보 ESG평가 ESG2(우수) 등급 획득</div>
                </div>
              </li>
              <li class="line-1">
                <div class="box">
                  <div class="m_hidden"><i class="icon icon-2"></i></div>
                  <div class="t1">
                    <div class="pc_hidden"><i class="icon icon-2"></i></div>브랜드 만족도 1위*
                  </div>
                  <div class="t2">*2023 대한민국 브랜드만족도 공인중개사 교육1위(한경비즈니스)</div>
                </div>
              </li>
              <li>
                <div class="box">
                  <div class="m_hidden"><i class="icon icon-2"></i></div>
                  <div class="t1">
                    <div class="pc_hidden"><i class="icon icon-2"></i></div>온라인 서점 판매 1위*
                  </div>
                  <div class="t2">*전문자격증/공무원/공인중개사 부분 YES24 베스트셀러 1위 (2020년,2021년,2022년 4월) ※매 월별 1위는
                    교재별로 다름</div>
                </div>
              </li>
              <li class="line-1">
                <div class="box">
                  <div class="m_hidden"><i class="icon icon-3"></i></div>
                  <div class="t1">
                    <div class="pc_hidden"><i class="icon icon-3"></i></div>초고화질 Full HD 온라인 강의*
                  </div>
                  <div class="t2">*현장의 느낌을 생생하게 제공하는 초고화질 FULL HD 온라인 강의</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <partner-banner />

      <div class="section-counsel">
        <div class="container">
          <div class="section-subject">
            <div class="title">
              성공을 만드는 변화의 시작,<br><span class="highlight-text"><span>에듀윌과 함께 하세요</span></span>
            </div>
            <div class="desc">
              곁에서 함께하는 든든한 파트너, 고민의 방향을 <br class="pc_hidden">제시해주는 동반자가 될 수 있도록 에듀윌이 함께 <br
                class="pc_hidden">하겠습니다.
            </div>
          </div>
          <ul>
            <li>
              <div class="title">기업·공공기관 교육</div>
              <div class="num"><span class="highlight-text"><span>02-397-0186</span></span></div>
              <!-- <div class="mail"><i class="icon icon-mail"></i>b2bedu@eduwill.net</div> -->
              <div class="btn"><a href="javascript:;" class="btn_counsel"
                                  @click="showCounsel('01')">상담신청</a></div>
            </li>
            <li>
              <div class="title">대학·특성화고 교육</div>
              <div class="num"><span class="highlight-text"><span>02-2650-3976</span></span></div>
              <!-- <div class="mail"><i class="icon icon-mail"></i>b2bedu@eduwill.net</div> -->
              <div class="btn"><a href="javascript:;" class="btn_counsel"
                                  @click="showCounsel('01')">상담신청</a></div>
            </li>
            <li>
              <div class="title">콘텐츠 공급·제휴</div>
              <div class="num"><span class="highlight-text"><span>02-6004-3804</span></span></div>
              <!-- <div class="mail"><i class="icon icon-mail"></i>b2bedu@eduwill.net</div> -->
              <div class="btn"><a href="javascript:;" class="btn_counsel"
                                  @click="showCounsel('01')">상담신청</a></div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 커리큘럼 팝업 -->
    <div class="curriculum_pop curriculum_pop_19">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">AI 교육</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>AICE 자격증</dt>
            <dd>강좌구성 : AICE Associate 취득 커리큘럼</dd>
            <dd>직무역량/전망 : 국내 유일 AI 국가공인 자격 시험</dd>
          </dl>
          <dl>
            <dt>중개업 AI 마케팅</dt>
            <dd>강좌구성 : 중개업 AI 마케팅 자동화 과정 전 강좌</dd>
            <dd>직무역량/전망 : 중개업 영업 마케팅 자동화 완성</dd>
          </dl>
          <dl>
            <dt>노션 AI</dt>
            <dd>강좌구성 : 노션 마스터+AI활용법 </dd>
            <dd>직무역량/전망 : 실전형 노션</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="curriculum_pop curriculum_pop_1">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">재무</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>재경관리사</dt>
            <dd>강좌구성 : 재무회계, 세무회계, 원가관리회계</dd>
            <dd>직무역랑/전망 : 회계, 세무, 원가, 경영관리 등 재경 전반의 지식과 실무 능력을 갖춘 재경전문가로의 역할 수행</dd>
          </dl>
          <dl>
            <dt>전산세무회계</dt>
            <dd>강좌구성 : 전산세무 1, 2급 / 전산회계 1, 2급</dd>
            <dd>직무역랑/전망 : 전산세무회계 프로그램을 활용한
              세무회계 분야의 실무 업무 능력 향상</dd>
          </dl>
          <dl>
            <dt>ERP 정보관리사 회계/인사</dt>
            <dd>강좌구성 : ERP 정보관리사 회계 1, 2급 /
              ERP 정보관리사 인사 1, 2급</dd>
            <dd>직무역랑/전망 : 회계관리, 인사관리 관련 ERP시스템
              실무 운용 능력 향상</dd>
          </dl>
        </div>
      </div>
    </div>

    <div class="curriculum_pop curriculum_pop_2">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">부동산·주택관리</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>공인중개사</dt>
            <dd>강좌구성 : 부동산학개론, 민법 및 민사특별법,
              부동산공법, 부동산공시법, 부동산세법,
              중개사법령 및 중개실무</dd>
            <dd>직무역랑/전망 : 부동산 중개, 관리 대행, 컨설팅, 경매/공매,
              사업타당성 분석 등에 대한 역량 향상</dd>
          </dl>
          <dl>
            <dt>부동산 경매</dt>
            <dd>강좌구성 : 등기, NPL/GPL, 토지경매 이론·사례,
              상가경매 이론·사례, 물가분석사례,
              재개발투자, 분양 등</dd>
            <dd>직무역랑/전망 : 투자분석 학습 및 경매 노하우 전수를 통한
              실전 활용 능력 향상</dd>
          </dl>
          <dl>
            <dt>부동산 마케팅</dt>
            <dd>강좌구성 : 부동산 크리에이터 개념 및 분석,
              스마트폰 기본 활용,
              SNS(블로그, 유튜브, 프롭테크 앱)활용</dd>
            <dd>직무역랑/전망 : SNS를 활용한 부동산 마케팅 방법 학습,
              부동산 앱/빅데이터를 통한 분석 능력 향상</dd>
          </dl>
          <dl>
            <dt>부동산 컨설팅</dt>
            <dd>강좌구성 : 상가 컨설팅: 투자조건분석, 상권분석,
              상가의 중개사고 예방 등
              토지 컨설팅: 재개발사례, 용도변경,
              물건분석, 활용방안 등</dd>
            <dd>직무역랑/전망 : 적합한 물건 탐색 및 법적 규제에 대한 이해,
              토지 개발 가능 여부 판단 능력 향상</dd>
          </dl>
          <dl>
            <dt>부동산 중개 영업</dt>
            <dd>강좌구성 : 영업 노하우 및 전략 설정, 물건 확보,
              물건 관리, 고객응대, 실전 광고 기법,
              고객 상담 기술 및 클로징,
              합리적 중개 보수 청구 요령</dd>
            <dd>직무역랑/전망 : 매출 상승을 위한 중개 영업 기법과 효과적 고객
              상담 스킬 향상</dd>
          </dl>
          <dl>
            <dt>주택관리사</dt>
            <dd>강좌구성 : 민법, 회계원리, 공동주택시설개론,
              주택관리관계법규, 공동주택관리실무</dd>
            <dd>직무역랑/전망 : 공동주택의 시설 및 환경과 관련된 행정업무,
              기술 및 안전관리 업무 능력 향상</dd>
          </dl>
          <dl>
            <dt>감정평가사</dt>
            <dd>강좌구성</dd>
            <dd>객관식 : 민법(총칙,물권), 경제학원론, 부동산학원론, 감정평가 관계 법규, 회계학</dd>
            <dd>주관식 : 감정평가실무, 감정펴가이론, 감정평가 및 보상법규</dd>
            <dd>직무역량/전망 : 대부분 감정평가법인으로 진출, 공기업, 금융기업, 한국감부동산원에 취업하거나 개인사무소를 개업</dd>
          </dl>
        </div>
      </div>
    </div>

    <div class="curriculum_pop curriculum_pop_3">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">전기·소방</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>전기(산업)기사</dt>
            <dd>강좌구성<br>필기: 전력공학, 전기기기, 회로이론,
              제어공학(기사), 전기자기학,
              전기설비기술기준 및 판단기준<br>
              실기: 전기설비 설계 및 관리</dd>
            <dd>직무역랑/전망 : 전기 안전 관리 능력 향상, 공사 시공, 감독 및
              전기 시설에 관한 보안 관리 업무 수행</dd>
          </dl>
          <dl>
            <dt>전기공사(산업)기사</dt>
            <dd>강좌구성<br>필기: 전력공학, 전기기기, 회로이론,
              제어공학(기사), 전기응용, 공사재료
              (기사), 전기설비기술기준 및 판단기준<br>
              실기: 전기설비 견적 및 시공</dd>
            <dd>직무역랑/전망 : 전기공사에 관한 기술 및 기초지식 함양,
              공사 시공, 제조공정 관리, 발전, 소전 및
              변전 시설의 유지관리 업무 수행</dd>
          </dl>
          <dl>
            <dt>전기기능사</dt>
            <dd>강좌구성<br>필기: 전기이론, 전기기기, 전기설비<br>
              실기: 전기설비 작업</dd>
            <dd>직무역랑/전망 : 회전기, 정지기, 제어장치, 전선, 케이블 등
              전기기계 및 기구를 설치, 보수, 관리하는
              능력 향상</dd>
          </dl>
          <dl>
            <dt>소방설비기사
              (전기/기계)</dt>
            <dd>강좌구성<br>필기: 소방원론, 소방관계법규,
              소방전기일반(전기), 소방유체역학(기계),
              소방전기(기계)시설의 구조 및 원리<br>
              실기: 소방전기(기계)시설 설계 및 시공실무</dd>
            <dd>직무역랑/전망 : 소방시설 전기(기계)분야의 시공, 관리,
              점검 등 방화 안전 관리에 대한 직무 역량 향상</dd>
          </dl>
          <dl>
            <dt>소방시설관리사</dt>
            <dd>강좌구성<br>필기: 소방안전관리론, 소방관련법령,
              소방수리학·약제화학 및 소방전기,
              위험물의 성상 및 시설기준,
              소방시설의 구조원리<br>
              실기: 소방시설의 점검실무 행정,
              소방시설의 설계 및 시공</dd>
            <dd>직무역랑/전망 : 화재 예방을 위한 소방시설 점검 및 정비, 위험물
              안전 성능 점검, 화기 취급 관련 업무 능력 향상</dd>
          </dl>
        </div>
      </div>
    </div>

    <div class="curriculum_pop curriculum_pop_4">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">위험물·산업안전</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>위험물산업기사</dt>
            <dd>강좌구성<br>필기: 일반화학, 화재예방과 소화방법,
              위험물의 성질과 취급<br>
              실기: 위험물 취급 실무</dd>
            <dd>직무역랑/전망 : 산업 현장의 일반작업자를 감독하며 시설에 대한
              안전점검을 실시할 수 있는 역량 확보</dd>
          </dl>
          <dl>
            <dt>위험물기능사</dt>
            <dd>강좌구성<br>필기: 화재예방과 소화방법,
              위험물의 화학적 성질 및 취급<br>
              실기: 위험물 취급 실무</dd>
            <dd>직무역랑/전망 : 위험물의 저장, 제조, 취급조에서 위험물을
              안전하게 취급하는 업무 수행 능력 향상</dd>
          </dl>
          <dl>
            <dt>산업안전
              (산업)기사</dt>
            <dd>강좌구성<br>필기: 안전관리론, 기계위험방지기술,
              화학설비위험방지기술,
              전기위험방지기술, 건설안전기술,
              인간공학 및 시스템 안전공학,<br>
              실기: 산업안전실무</dd>
            <dd>직무역랑/전망 : 산업 현장의 산업재해 예방 계획 수립 및 위험
              방지에 관한 사고 사례 분석, 개선 능력 향상</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="curriculum_pop curriculum_pop_5">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">건축·토목</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>건축(산업)기사</dt>
            <dd>강좌구성<br>필기: 건축계획, 건축시공,
              건축구조, 건축설비,
              건축관계법규<br>
              실기: 건축시공실무</dd>
            <dd>직무역랑/전망 : 건축물의 계획, 설계, 시공에 대한
              공학적 지식과 기술 겸비,
              안전한 공사 진행을 위한 감독 능력 향상</dd>
          </dl>
          <dl>
            <dt>토목(산업)기사</dt>
            <dd>강좌구성<br>필기: 응용역학, 측량학, 수리학 및 수문학,
              철근콘크리트 및 강구조,
              토질 및 기초, 상하수도공학<br>
              실기: 토목설계 및 시공실무</dd>
            <dd>직무역랑/전망 : 구조 건설에 대한 전문적인 지식과
              기술 겸비, 토목 시설의 설계, 건설, 유지,
              보수 등의 업무 수행 능력 향상</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="curriculum_pop curriculum_pop_6">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">물류·유통·무역</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>물류관리사</dt>
            <dd>강좌구성 : 물류관리론, 화물운송론,
              국제물류론, 보관하역론,
              물류관련법규</dd>
            <dd>직무역랑/전망 : 원자재 조달, 물품 생산, 보관, 가공, 유통 등
              물류관리에 대한 전문적인 지식 향상</dd>
          </dl>
          <dl>
            <dt>유통관리사</dt>
            <dd>강좌구성 : 유통물류일반관리, 상권분석,
              유통마케팅, 유통정보</dd>
            <dd>직무역랑/전망 : 소비자와 생산자 간의 커뮤니케이션,
              소비자 동향 파악 등 판매 현장의
              유통관리능력 향상</dd>
          </dl>
          <dl>
            <dt>ERP 정보관리사
              생산/물류</dt>
            <dd>강좌구성 : ERP 정보관리사 생산 1, 2급 /
              ERP 정보관리사 물류 1, 2급</dd>
            <dd>직무역랑/전망 : 생산관리, 물류관리 관련 ERP 시스템
              실무 운용 능력 향상</dd>
          </dl>
          <dl>
            <dt>국제무역사</dt>
            <dd>강좌구성 : 무역규범, 무역결제, 무역계약, 무역영어</dd>
            <dd>직무역랑/전망 : 무역 관련 계약 서류 작성 등
              무역 업무 능력 향상,
              무역규범 및 외환실무에 대한
              폭넓은 이해 가능</dd>
          </dl>
          <dl>
            <dt>무역영어</dt>
            <dd>강좌구성 : 영문해석, 영작문, 무역실무</dd>
            <dd>직무역랑/전망 : 무역 관련 영문 서류 작성,
              번역 능력 향상 및 무역 전문 지식 습득</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="curriculum_pop curriculum_pop_7">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">경비·행정·감정</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>경비지도사</dt>
            <dd>강좌구성 : 법학개론, 민간경비론, 경비업법, 경호학</dd>
            <dd>직무역랑/전망 : 시설경비, 신변보호, 국가중요시설의
              방호 등 경찰력의 보완적 수행 능력 향상</dd>
          </dl>
          <dl>
            <dt>행정사</dt>
            <dd>강좌구성 : 민법총칙, 행정법, 행정학개론,
              민법계약, 행정절차론, 사무관리론,
              행정사실무법</dd>
            <dd>직무역랑/전망 : 행정기관에 제출하는 서류의 작성,
              번역, 제출 대행, 신청·청구 및 신고 등의
              대리 업무 능력 향상</dd>
          </dl>
          <dl>
            <dt>도로교통사고
              감정사</dt>
            <dd>강좌구성 : 교통관련법규, 교통사고조사론,
              교통사고재현론, 차량운동학,
              교통사고조사분석서 작성 및 재현 실무</dd>
            <dd>직무역랑/전망 : 교통사고 원인 규명 및 해석, 교통사고
              재현, 교통사고 감정서 작성 역량 향상</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="curriculum_pop curriculum_pop_8">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">상담·복지</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>직업상담사</dt>
            <dd>강좌구성 : 직업상담학, 직업심리학, 직업정보론,
              노동시장론, 노동관계법규, 직업상담실무</dd>
            <dd>직무역랑/전망 : 노동법규 관련 상담, 직업정보 수집, 분석,
              제공, 적성검사 실시 및 해석 등의
              직업상담 능력 향상</dd>
          </dl>
          <dl>
            <dt>사회복지사 1급</dt>
            <dd>강좌구성 : 인간행동과 사회환경, 사회복지조사론,
              사회복지실천론, 사회복지실천기술론,
              지역사회복지론, 사회복지정책론,
              사회복지행정론, 사회복지법제론</dd>
            <dd>직무역랑/전망 : 사회복지 프로그램의 개발 및 운영,
              시설 거주자의 생활지도, 상담 업무 능력 향상</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="curriculum_pop curriculum_pop_9">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">경제·경영·시사</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>매경 TEST</dt>
            <dd>강좌구성 : 경제, 경영</dd>
            <dd>직무역랑/전망 : 기업 비즈니스 현장에서 요구되는 경제,
              경영 지식과 사고력, 시사적인 감각 향상</dd>
          </dl>
          <dl>
            <dt>한경 TESAT</dt>
            <dd>강좌구성 : 미시경제, 거시경제</dd>
            <dd>직무역랑/전망 : 경제 원리 이해 및 경제 마인드 향상,
              업무 배치/승진 등 평가 지표로 활용</dd>
          </dl>
          <dl>
            <dt>서비스경영자격
              (모듈A)</dt>
            <dd>강좌구성 : 비즈니스 에티켓/매너, 이미지메이킹,
              고객 심리의 이해, 고객커뮤니케이션,
              회의 기획 및 의전</dd>
            <dd>직무역랑/전망 : 고객 심리 이해 및 현장 커뮤니케이션
              실무 능력 양성</dd>
          </dl>
          <dl>
            <dt>서비스경영자격
              (모듈B)</dt>
            <dd>강좌구성 : 서비스 세일즈 및 고객 상담,
              고객 관계 관리, VOC와 컴플레인,
              서비스 유통 관리, 교육 훈련 및 코칭·멘토링</dd>
            <dd>직무역랑/전망 : 서비스 유통관리 및 코칭/멘토링,
              고객 관리 능력 향상</dd>
          </dl>
          <dl>
            <dt>서비스경영자격
              (모듈C)</dt>
            <dd>강좌구성 : 서비스 산업개론, 서비스 프로세스 개발 및
              품질관리, 수요 및 공급관리, 인적자원관리,
              고객만족경영</dd>
            <dd>직무역랑/전망 : 우수한 서비스 프로세스 설계,
              서비스 운영 전략 관리 능력 향상</dd>
          </dl>
          <dl>
            <dt>시사상식</dt>
            <dd>강좌구성 : 정치, 행정, 경제, 사회, 국제, 문화, IT 등
              분야별 최신 상식</dd>
            <dd>직무역랑/전망 : 다방면의 상식으로 사고의 틀 확대,
              전문적이고 깊이 있는 지식 습득</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="curriculum_pop curriculum_pop_10">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">한국사·한국어</div>
        </div>
        <div class="curriculum_contents">

          <dl>
            <dt>한국사능력검정시험</dt>
            <dd>강좌구성 : 심화(1급/2급/3급), 기본(4급/5급/6급)</dd>
            <dd>직무역랑/전망 : 역사적 사고력 증진 및 역사 학습 능력 향상,
              인사고과 및 취업 가산점 적용</dd>
          </dl>
          <dl>
            <dt>KBS 한국어능력시험</dt>
            <dd>강좌구성 : 문법 능력, 이해 능력, 표현 능력,
              창안 능력, 국어 문화 능력</dd>
            <dd>직무역랑/전망 : 어휘, 듣기, 말하기, 창안 능력 및
              국어 문화 능력 강화</dd>
          </dl>
          <dl>
            <dt>실용글쓰기</dt>
            <dd>강좌구성 : 어휘와 문장, 직무 글쓰기,
              공학·기술 글쓰기, 독해와 글쓰기,
              화법과 글쓰기</dd>
            <dd>직무역랑/전망 : 기안서, 품의서, 제안서, 보고서,
              기획서 등 직무 문서 작성 능력 향상</dd>
          </dl>
          <dl>
            <dt>TOPIK I,II</dt>
            <dd>강좌구성 : 듣기, 읽기, 쓰기(어휘문법)</dd>
            <dd>직무역랑/전망 : 재외동포·외국인의 한국어 능력 향상</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="curriculum_pop curriculum_pop_11">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">IT자격증</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>컴퓨터활용능력 1급</dt>
            <dd>강좌구성<br>필기: 컴퓨터일반, 스프레드시트 일반,
              데이터베이스 일반<br>
              실기: 스프레드시트 실무, 데이터베이스 실무</dd>
            <dd>직무역랑/전망 : 스프레드시트, 데이터베이스 활용 능력 향상,
              공기업 취업 시 가산점 적용</dd>
          </dl>
          <dl>
            <dt>컴퓨터활용능력 2급</dt>
            <dd>강좌구성<br>필기: 컴퓨터일반, 스프레드시트 일반,<br>
              실기: 스프레드시트 실무</dd>
            <dd>직무역랑/전망 : 스프레드시트 활용 능력 향상,
              공기업 취업 시 가산점 적용</dd>
          </dl>
          <dl>
            <dt>정보처리기사</dt>
            <dd>강좌구성<br>필기: 소프트웨어 설계, 소프트웨어 개발
              데이터베이스 구축, 프로그래밍 언어
              활용, 정보시스템 구축관리<br>
              실기: 정보처리 실무</dd>
            <dd>직무역랑/전망 : 정보시스템 개발 요구 사항 이해,
              각 업무에 맞는 소프트웨어의 기능에 관한 설계,
              구현 및 수행 능력 향상</dd>
          </dl>
          <dl>
            <dt>워드프로세서</dt>
            <dd>강좌구성<br>필기: 워드프로세서 일반, PC운영체제,
              컴퓨터와 정보 활용<br>
              실기: 문서편집 기능</dd>
            <dd>직무역랑/전망 : 워드프로세서 프로그램 운영 및
              편집 능력 향상</dd>
          </dl>
          <dl>
            <dt>사무자동화
              산업기사</dt>
            <dd>강좌구성<br>필기: 정보통신개론, 사무경영관리개론,
              사무자동화시스템, 프로그래밍일반<br>
              실기: 사무자동화 실무</dd>
            <dd>직무역랑/전망 : 사무환경에서 필요로 하는 정보관리,
              사무처리 등의 계획, 추진 및 운용 능력 향상</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="curriculum_pop curriculum_pop_12">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">NCS</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>의사소통 능력</dt>
            <dd>강좌구성 : 문서이해 능력, 문서작성 능력, 경청 능력,
              의사표현 능력, 기초외국어 능력</dd>
            <dd>직무역랑/전망 : 회의록 및 공문서 작성, 적절한 의사표현,
              외국어 소통 능력 향상</dd>
          </dl>
          <dl>
            <dt>조직이해 능력</dt>
            <dd>강좌구성 : 국제감각, 조직체제 이해 능력,
              경영 이해 능력, 업무 이해 능력</dd>
            <dd>직무역랑/전망 : 비즈니스 상식, 업무의 종류와 특성 이해를 통한
              직무 역량 향상</dd>
          </dl>
          <dl>
            <dt>대인관계 능력</dt>
            <dd>강좌구성 : 팀워크 능력, 리더십 능력, 협상 능력,
              갈등관리 능력, 고객서비스 능력</dd>
            <dd>직무역랑/전망 : 다양한 배경의 사람들과 조화롭게 업무를
              수행할 수 있는 능력 향상</dd>
          </dl>
          <dl>
            <dt>기술 능력</dt>
            <dd>강좌구성 : 기술이해 능력, 기술선택 능력, 기술적용 능력</dd>
            <dd>직무역랑/전망 : 기술의 원리와 절차 이해를 바탕으로
              효과적인 기술 선택 및 활용 능력 향상</dd>
          </dl>
          <dl>
            <dt>자기개발 능력</dt>
            <dd>강좌구성 : 자아인식 능력, 자기관리 능력, 경력개발 능력</dd>
            <dd>직무역랑/전망 : 자기관리 및 경력개발 계획 통한
              업무 수행 성과 향상</dd>
          </dl>
          <dl>
            <dt>자원관리 능력</dt>
            <dd>강좌구성 : 자원관리 개요, 시간관리 능력,
              예산관리 능력, 물적자원관리 능력,
              인적자원관리 능력</dd>
            <dd>직무역랑/전망 : 한정된 자원을 활용한 효율적 업무수행을 통한
              업무 성과 향상</dd>
          </dl>
          <dl>
            <dt>직업윤리</dt>
            <dd>강좌구성 : 근로 윤리, 공동체 윤리</dd>
            <dd>직무역랑/전망 : 개인/직업윤리 조화를 통한 책임감 향상</dd>
          </dl>
        </div>
        <div class="title_line">
          <div class="tit">취업</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>대기업 취업</dt>
            <dd>강좌구성 : 삼성GSAT, SK그룹, CJ그룹, LG그룹, 농협은행, 제약·바이오</dd>
          </dl>
          <dl>
            <dt>공기업 취업</dt>
            <dd>강좌구성 : 코레일, 한국전력공사, 건강보험공단, 서울교통공사, 부산교통공사, 한국수력원자력, 남부발전,
              남동발전, 동서발전, 서부발전, 중부발전</dd>
          </dl>
          <dl>
            <dt>면접/자소서
              취업 특강</dt>
            <dd>강좌구성 : 신입사원을 위한 직장생활 기본기, 직무분석 및 커리어로드맵, 이력서 작성법,
              1:1자소서 랜선 컨설팅, 강소기업 분석 및 지원전략, 취업포털 활용, 입사지원 실습,
              NCS 자소서&면접 + AI 면접 전략 특강, 면접 커뮤니케이션 전략, 면접 답변노트 작성 및
              답변 실습, 모의 면접, 면접 피드백, 시사상식</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="curriculum_pop curriculum_pop_13">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">전직지원·창업</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>재취업/창업</dt>
            <dd>강좌구성 : 고용 환경의 이해, 커리어 디자인, 재취업 직무
              적성, 재취업 역량 강화, 시니어 창업 이해,
              창업트렌드, 창업아이템, 사업계획 수립,
              정부지원제도 활용</dd>
            <dd>직무역랑/전망 : 고용시장 트렌드에 대응하여
              재취업, 창업에서의 실전 능력 확보</dd>
          </dl>
          <dl>
            <dt>생애/재무</dt>
            <dd>강좌구성 : 변화관리, 생애설계, 인생 2막 관계관리,
              퇴직 후 숨은 내 돈 찾기, 절세전략,
              주거안정, 부동산 자산관리전략</dd>
            <dd>직무역랑/전망 : 자기진단 및 역량 파악,
              인생 2막, 3막의 비전 준비</dd>
          </dl>
          <dl>
            <dt>반려견 전문가</dt>
            <dd>강좌구성 : 반려동물 관리 전문가, 동물행동상담사,
              전문 펫시터, 반려동물 영양관리사,
              펫 패션 디자이너</dd>
            <dd>직무역랑/전망 : 동물병원, 분양샵, 학교(유치원),
              사료, 펫호텔, 기타 서비스업 등
              광범위한 분야로의 진출</dd>
          </dl>
          <dl>
            <dt>한식조리기능사</dt>
            <dd>강좌구성 : 한식 위생관리, 안전관리, 구매관리,
              재료관리, 기초조리실무, 한식 조리작업</dd>
            <dd>직무역랑/전망 : 한식 조리에 대한 전문가로 인정,
              높은 수익과 직업적 안정성 보장</dd>
          </dl>
          <dl>
            <dt>양식조리기능사</dt>
            <dd>강좌구성 : 양식 위생관리, 안전관리, 구매관리,
              재료관리, 기초조리실무, 양식 조리작업</dd>
            <dd>직무역랑/전망 : 양식 조리에 대한 전문가로 인정,
              높은 수익과 직업적 안정성 보장</dd>
          </dl>
          <dl>
            <dt>일식조리기능사</dt>
            <dd>강좌구성 : 일식 위생관리, 안전관리, 구매관리,
              재료관리, 기초조리실무, 일식 조리작업</dd>
            <dd>직무역랑/전망 : 일식 조리에 대한 전문가로 인정,
              높은 수익과 직업적 안정성 보장</dd>
          </dl>
          <dl>
            <dt>중식조리기능사</dt>
            <dd>강좌구성 : 중식 위생관리, 안전관리, 구매관리,
              재료관리, 기초조리실무, 중식 조리작업</dd>
            <dd>직무역랑/전망 : 중식 조리에 대한 전문가로 인정,
              높은 수익과 직업적 안정성 보장</dd>
          </dl>
          <dl>
            <dt>떡제조기능사</dt>
            <dd>강좌구성 : 떡제조 및 위생관리, 안전관리, 떡제조 실무</dd>
            <dd>직무역랑/전망 : 전통음식에 대한 이해 확대, 시장 선점</dd>
          </dl>
          <dl>
            <dt>제과/제빵기능사</dt>
            <dd>강좌구성 : 제과/제빵 재료, 영양학, 식품위생학,
              제과/제빵 실무</dd>
            <dd>직무역랑/전망 : 제과, 제빵부서, 단체 급식소,
              해외 유람선, 해외 등 취업</dd>
          </dl>
          <dl>
            <dt>화장품
              조제관리사</dt>
            <dd>강좌구성 : 화장품법의 이해, 유통화장품의 안전관리,
              화장품 제조 및 품질관리,
              맞춤형 화장품의 이해</dd>
            <dd>직무역랑/전망 : 화장품 이해 능력 향상,
              맞춤형 화장품의 혼합, 소분 업무에 적용</dd>
          </dl>
          <dl>
            <dt>메이크업
              미용사</dt>
            <dd>강좌구성 : 메이크업 위생관리, 고객서비스, 카운슬링,
              이미지 연출 및 메이크업 디자인</dd>
            <dd>직무역랑/전망 : 메이크업에 관한 숙련 기능 강화,
              현장 업무를 수용할 수 있는 능력 향상</dd>
          </dl>
          <dl>
            <dt>네일미용사</dt>
            <dd>강좌구성 : 네일 숍 위생서비스, 네일 화장물 적용 및
              네일미용 관리, 네일미용 실무</dd>
            <dd>직무역랑/전망 : 기기 및 제품 활용도 향상,
              적절한 관리법으로 현장 업무 수행</dd>
          </dl>
          <dl>
            <dt>스포츠지도사
              (전문/생활)</dt>
            <dd>강좌구성 : 스포츠심리학, 운동생리학, 스포츠사회학,
              운동역학, 스포츠교육학, 스포츠윤리,
              한국체육사</dd>
            <dd>직무역랑/전망 : 학교나 단체의 감독 및 코치,
              일선 시민들의 생활체육 활동 지도</dd>
          </dl>
          <dl>
            <dt>ICT인지건강관리사 (민간자격증 과정)</dt>
            <dd>강좌구성: 치매의 이해, 두뇌 및 인지 기능 이해, 치매 제도 등 실생활 사례, ICT 기술 활용 두뇌 관리, 시니어 대상 교수법 및 상담 전략, 강사 커리어 디자인, 실습
              평가</dd>
            <dd>직무역량/전망: 전문가 수준의 두뇌 인지 건강 및 치매에 대한 영역별 지식 함양, 치매 예방 교육 강사 및 1:1 맞춤형 예방관리사 등 분야로의 진출</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="curriculum_pop curriculum_pop_14">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">HRD·전문직무</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>멘탈트레이닝</dt>
            <dd>강좌구성 : 자기효능감 향상, 목표수립 및 실천, 불안 관리/스트레스 관리,
              중요한 순간을 위한 이미지 트레이닝, 습관 만들기, 루틴 만들기</dd>
          </dl>
          <dl>
            <dt>팀워크향상</dt>
            <dd>강좌구성 : 팀 목표 공유, 역할 분배, 이해와 소통, 팀 응집성(팀워크) 향상,
              팀 스트레스 관리를 위한 명상, 스트레칭, 건강한 조직 만들기</dd>
          </dl>
          <dl>
            <dt>블록체인전문가</dt>
            <dd>강좌구성 : 블록체인 기술 이해, 기술 동향, 사업성 검토 및 평가, 창업 및 시장 동향, 산업 적용 사례</dd>
          </dl>
          <dl>
            <dt>증권전문가</dt>
            <dd>강좌구성 : 주식분석, 주식시장의 이해, 주식투자 분석 및 전략, 법규와 윤리, 시세정보 활용</dd>
          </dl>
          <dl>
            <dt>HRD</dt>
            <dd>강좌구성 : 리더십역량 강화, 소통역량 강화, 업무역량 향상, 팀워크 /조직 활성화, 경영시뮬레이션</dd>
          </dl>
          <dl>
            <dt>창업과정</dt>
            <dd>강좌구성 : 은퇴자 창업 과정</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="curriculum_pop curriculum_pop_15">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">산업안전보건</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>관리감독자
              정기 교육</dt>
            <dd>대상 : 제조업
              도소매업
              건설업
              음식서비스업
              기타서비스업
              보건업 등</dd>
            <dd>시간 : 연간 16시간 이상</dd>
          </dl>
          <dl>
            <dt>근로자
              정기 교육</dt>
            <dd>대상 : 제조업
              도소매업
              건설업
              음식서비스업
              기타서비스업
              보건업 등</dd>
            <dd>시간 : 매 분기 3시간
              또는 6시간 이상</dd>
          </dl>
          <dl>
            <dt>채용 시 교육</dt>
            <dd>대상 : 제조업
              도소매업
              건설업
              음식서비스업
              기타서비스업
              보건업 등</dd>
            <dd>시간 : 채용 시 8시간 이상</dd>
          </dl>
          <dl>
            <dt>특별교육</dt>
            <dd>대상 : 제조업
              도소매업
              건설업
              음식서비스업
              기타서비스업
              보건업 등</dd>
            <dd>시간 : 40개 작업에
              해당하는 경우
              16시간 이상</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="curriculum_pop curriculum_pop_16">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">어학</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>TOEIC</dt>
            <dd>강좌구성: LC(베이직/실전), RC(베이직/실전), 기초영문법, VOCA</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="curriculum_pop curriculum_pop_17">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">편입</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>인문계 대비</dt>
            <dd>강좌구성: 편입영어, 편입보카</dd> <br>
            <dt>자연계 대비</dt>
            <dd>강좌구성 : 편입영어, 편입수학</dd> <br>
            <dt>경찰대 대비</dt>
            <dd>강좌구성 : 편입영어, 편입 언어논리</dd> <br>
            <dt>의치수의대 대비 </dt>
            <dd>강좌구성 : 의치수의대 생물, 의치수의대 화학</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="curriculum_pop curriculum_pop_18">
      <a class="curriculum_pop_close"><img
          src="//img.eduwill.net/resources/b2b/dev/images/navi-icon-nav-close.png" /></a>
      <div class="wrapper">
        <div class="title_line">
          <div class="tit">인사·노무</div>
        </div>
        <div class="curriculum_contents">
          <dl>
            <dt>공인노무사</dt>
            <dd>강좌구성</dd>
            <dd>1차 : 노동법, 민법, 사회보험법, 경제학원론, 경영학개론</dd>
            <dd>2차 : 노동법, 인사노무관리론, 행정쟁송법, 경영조직론, 노동경제학, 민사소송법</dd>
            <dd>면접 : 공인노무사법 시행령 제4조의제3항의 평정사항</dd>
            <dd>직무역량/전망 : 노무법인이나 일반 기업체, 공기업, 공공기관 등으로 취업, 개인 사무소를 개업하거나 노무법인을 설립</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="float_counsel m_hidden" @click="showCounsel('01')">
      <div class="group-wrap">
        <div class="group">
          <div class="text">에듀윌과 함께<br>변화를 시작하세요.</div>
          <div class="button"><a href="javascript:;" @click="show_counsel('01')">맞춤상담신청</a></div>
          <div class="ico-hand"></div>
        </div>
      </div>
    </div>
    <div class="float_counsel_mobile pc_hidden" @click="showCounsel('01')">
      <a href="#" class="circle_counsel">맞춤<br>상담</a>
    </div>
  </div>

</template>

<script>
import MainHeader from "@/layouts/MainHeader";
import PartnerBanner from "@/components/PartnerBanner";
import eventBus from "@/eventBus/event-bus";

export default {

  name: "home",
  components: {MainHeader, PartnerBanner},
  data() {
    return {}
  },

  computed: {
  },

  methods: {
    showCounsel(v) {
      eventBus.$emit("show-counsel", v);
    },
    closeCurriculum(v) {
      $('.curriculum_pop_' + v).bPopup().close();
    },
    showCurriculum(v) {
      $('.curriculum_pop_' + v).bPopup();
    }
  },

  created() {
  },
  beforeMount() {
  },
  mounted() {
    $(".section-menu .item > div").on("mouseover", function(){
      var target = $(this).attr("class");
      $(".section-menu .bg").find("." + target).addClass("on").siblings().removeClass("on")
    });
    $(".section-menu .item > div").on("mouseover", function(){
      var target = $(this).attr("class");
      $(".section-menu .bg").find("." + target).fadeIn().siblings().fadeOut()
    });
  },
}
</script>

<style scoped>

</style>
